import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);
export const useTheme = () => useContext(ThemeContext);

export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(() => {
        if (typeof window === "undefined") return "light";
        return localStorage.getItem("bl_theme") || "light";
    });

    // Persist preference. We deliberately do NOT touch document.documentElement
    // here — the `dark` class is applied on the AppShell root so marketing
    // pages (landing, pricing, login, register) stay in the light palette.
    useEffect(() => {
        try {
            localStorage.setItem("bl_theme", theme);
        } catch {
            /* storage disabled — ignore */
        }
    }, [theme]);

    const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

    return (
        <ThemeContext.Provider value={{ theme, setTheme, toggle }}>
            {children}
        </ThemeContext.Provider>
    );
}
